module.exports = __webpack_public_path__ + "media/images/icon_arrow-thin-6a71c740b76fb5f5bf516070f1e47fde.svg";